import {
  DISPLAY_PRODUCT,
  GET_RECOMMENDED_ITEMS_FAILURE,
  GET_RECOMMENDED_ITEMS_PENDING,
  GET_RECOMMENDED_ITEMS_SUCCESS,
  PRODUCT_OK,
  PRODUCT_NOT_OK,
  RESET_TO_INITIAL_STATE,
} from '../actions/product'

const initialState = {
  displayedProduct: null,
  displayedProductBySlug: null,
  productsBySlug: {},
  recommendedItems: {
    error: null,
    isPending: false,
    items: [],
  },
}

export default function reducer(state = initialState, action) {
  let newState

  switch (action.type) {
    case RESET_TO_INITIAL_STATE: {
      newState = initialState
      break
    }

    case DISPLAY_PRODUCT: {
      newState = {
        displayedProductBySlug: action.data,
      }
      break
    }

    case GET_RECOMMENDED_ITEMS_FAILURE: {
      newState = {
        recommendedItems: {
          ...state.recommendedItems,
          error: action.payload,
          isPending: false,
        },
      }
      break
    }

    case GET_RECOMMENDED_ITEMS_PENDING: {
      newState = {
        recommendedItems: {
          ...state.recommendedItems,
          error: null,
          isPending: true,
        },
      }
      break
    }

    case GET_RECOMMENDED_ITEMS_SUCCESS: {
      newState = {
        recommendedItems: {
          ...state.recommendedItems,
          isPending: false,
          items: action.payload,
        },
      }
      break
    }

    case PRODUCT_NOT_OK: {
      const newProductsBySlug = Object.assign({}, state.productsBySlug, {
        [action.data]: false,
      })
      newState = Object.assign({}, state, {
        productsBySlug: newProductsBySlug,
      })
      newState.displayedProduct = newState.productsBySlug[state.displayedProductBySlug]
      break
    }

    case PRODUCT_OK: {
      const newProductsBySlug = Object.assign({}, state.productsBySlug, {
        [action.data.urlSlug]: {...action.data, status: 'OK'},
      })
      newState = Object.assign({}, state, {
        productsBySlug: newProductsBySlug,
      })
      newState.displayedProduct = newState.productsBySlug[state.displayedProductBySlug]
      break
    }

    default: {
      break
    }
  }

  return newState ? Object.assign({}, state, newState) : state
}
